const CODE_DOWN = "ArrowDown";
const CODE_END = "End";
const CODE_HOME = "Home";
const CODE_LEFT = "ArrowLeft";
const CODE_PAGEDOWN = "PageDown";
const CODE_PAGEUP = "PageUp";
const CODE_RIGHT = "ArrowRight";
const CODE_UP = "ArrowUp";
const RX_UNDERSCORE = /_/g;
const RX_LOWER_UPPER = /([a-z])([A-Z])/g;
const RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
const RX_START_SPACE_WORD = /(\s|^)(\w)/g;
const RX_FIRST_START_SPACE_WORD = /(\s|^)(\w)/;
const RX_SPACE_SPLIT = /\s+/;
const RX_HASH = /^#/;
const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
const RX_SPACES = /[\s\uFEFF\xA0]+/g;
export {
  CODE_LEFT as C,
  RX_SPACE_SPLIT as R,
  CODE_UP as a,
  CODE_RIGHT as b,
  CODE_DOWN as c,
  RX_HASH_ID as d,
  RX_HASH as e,
  RX_NUMBER as f,
  RX_SPACES as g,
  RX_REGEXP_REPLACE as h,
  RX_UNDERSCORE as i,
  RX_LOWER_UPPER as j,
  RX_FIRST_START_SPACE_WORD as k,
  RX_START_SPACE_WORD as l,
  CODE_PAGEUP as m,
  CODE_PAGEDOWN as n,
  CODE_HOME as o,
  CODE_END as p
};
//# sourceMappingURL=constants-DameGf19.mjs.map
